'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.updatePhone = updatePhone;
exports.sendPromo = sendPromo;
exports.isLoaded = isLoaded;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-frontend/dtac/LOAD';
var LOAD_SUCCESS = 'redux-frontend/dtac/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/dtac/LOAD_FAIL';

var SEND = 'redux-frontend/dtac/SEND';
var SEND_SUCCESS = 'redux-frontend/dtac/SEND_SUCCESS';
var SEND_FAIL = 'redux-frontend/dtac/SEND_FAIL';

var UPDATE_PHONE = 'redux-frontend/dtac/UPDATE_PHONE';

var initialState = {
  loaded: false,
  loading: false,
  inspirations: [],
  trips: [],
  localExperts: [],
  reviews: [],
  phone: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SEND:
      return (0, _extends3.default)({}, state);
    case SEND_SUCCESS:
      return (0, _extends3.default)({}, state);
    case SEND_FAIL:
      return (0, _extends3.default)({}, state);
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        inspirations: action.result.inspiration_layouts,
        trips: action.result.featured_trips,
        localExperts: action.result.featured_local_experts,
        reviews: action.result.featured_reviews
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case UPDATE_PHONE:
      return (0, _extends3.default)({}, state, {
        phone: action.value
      });
    default:
      return state;
  }
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/info/dtac');
    }
  };
}

function updatePhone(value) {
  return {
    type: UPDATE_PHONE,
    value: value
  };
}

function sendPromo() {
  return {
    types: [SEND, SEND_SUCCESS, SEND_FAIL],
    promise: function promise(client) {
      return client.get('/session/promo-dtac');
    }
  };
}

function isLoaded(globalState) {
  return globalState.dtac && globalState.dtac.loaded;
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/dtac.js
// module id = 324
// module chunks = 47